import PrevisionButton from "@/components/prevision-button/PrevisionButton";

import { getPrevisionButtonStatus } from "@/blocks/weather-forecast-prevision-city/helpers/prevision-button-helper";
import { WEATHER_STORE } from "@/store/store";
import { useDispatch, useSelect } from "@wordpress/data";
import { WeatherDispatch, WeatherSelect } from "@/store/type";
import { t } from "i18next";
import { getForecastByDate } from "@/helpers/format-forecast-data-by-date";
import { labelHeaderMarine } from "../constants/label-header-marine-constant";
import { getCurrentDateWithDay } from "@/helpers/format-date";

import Skeleton from "@/components/skeletons/Skeleton";
import PrevisionTable from "@/components/prevision-table/PrevisionTable";

import "./style.scss";

export const App = () => {
	const { setPrevisionDate } = useDispatch(WEATHER_STORE) as WeatherDispatch;

	const {
		date: dateSelected,
		marineData = [],
		isLoading,
		error,
	} = useSelect((select: (store: typeof WEATHER_STORE) => WeatherSelect) => {
		const store = select(WEATHER_STORE);

		return {
			...store.getMarineDate(),
			...store.getMarineForecastState(),
		};
	});

	const { day, date } = getCurrentDateWithDay(dateSelected);

	const dataToMap = getForecastByDate({
		selectedDate: dateSelected,
		forecastData: marineData,
	});

	return (
		<div className="marine-forecast-prevision">
			<PrevisionButton
				isPrev={true}
				isActive={getPrevisionButtonStatus({
					direction: "prev",
					dateSelected,
					addDate: 5,
				})}
				handleClick={(action: "prev" | "next") =>
					setPrevisionDate({
						action,
						forecastType: "marine",
						dateStore: dateSelected,
					})
				}
			/>

			<div className="table-wrapper">
				{isLoading ? (
					<div className="table-wrapper" style={{ height: 400 }}>
						<div className="prevision-table">
							<Skeleton length={8} />
						</div>
					</div>
				) : error ? (
					<div className="error">
						<p>{t("fetchError")}</p>
					</div>
				) : (
					dataToMap && (
						<PrevisionTable
							day={day}
							date={date}
							type="marine"
							labelHeader={labelHeaderMarine}
							data={dataToMap}
						/>
					)
				)}
			</div>

			<PrevisionButton
				isPrev={false}
				isActive={getPrevisionButtonStatus({
					direction: "next",
					dateSelected,
					addDate: 4,
				})}
				handleClick={(action: "prev" | "next") =>
					setPrevisionDate({
						action,
						forecastType: "marine",
						dateStore: dateSelected,
					})
				}
			/>
		</div>
	);
};

export default App;
